import React from 'react'
import styled from 'styled-components'
import PropTypes from 'prop-types'
import moment from 'moment'
import { Button, Colors } from 'advenio-components'

const CellContainer = styled.div`
  display: flex;
  align-items: center;
  position: relative;
  background-color: ${({ index }) => (index % 2) === 0 ? '#f7f8f9' : 'white'};
  padding-left: 32px;

  button {
    display: none;
  }

  &:hover{
    button {
      display: flex;
    }
  }

  @media (max-width:767px) {
    height: 60px;
    padding-left: 16px;
    button {
      display: none !important;
    }
  }
`
const DeleteButton = styled(Button)`
  display: flex;
  align-items: center;
  justify-content: space-around;
  height: 42px;
  margin-right: 16px;
  padding: 10px 16px;
  font-size: 12px;

  @media (max-width:1300px) {
    height: 32px;
    width: 60px;
    margin-right: 8px;
    padding: 4px 8px;
    font-size: 12px;
  }
`
const Circle = styled.div`
  height: 16px;
  width: 16px;
  border-radius: 50%;
  border: 3px solid;
  border-color: ${({ color }) => color};
  z-index: 99;

  @media (max-width: 767px) {
    height: 8px;
    width: 8px;
  }
`
const CircleContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 20px;
  width: 20px;
  border-radius: 20px;
  background-color: ${({ index }) => (index % 2) === 0 ? 'white' : 'white'};
  z-index: 99;

  @media (max-width:767px) {
    height: 16px;
    width: 16px;
  }
`
const InfoContainer = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  padding: 16px;

  @media (max-width:767px) {
    font-size: 15px;
    padding: 16px 8px;
  }
`
const ContextContainer = styled.div`
  margin-right: 16px;
  color: ${Colors.gray500};
  font-size: 12px;

  @media (max-width:768px) {
    font-size: 10px;
  }
`
const CancelIcon = styled.img`
  height: 15px;
  padding-right: 4px;
  padding-left: 4px;
`
const DeleteLabel = styled.div`
  margin-right: 4px;
`
const LinkLine = styled.div`
  position: absolute;
  top: ${props => props.top ? '50%' : '0'};
  left: 41px;
  display: ${props => props.alone ? 'none' : 'block'};
  height: ${props => props.top || props.bottom ? '50%' : '100%'};
  width: 0;
  border: solid 1px #CCCCCC;

  @media (max-width:767px) {
    top: ${props => props.top ? '30px' : '0'};
    left: 23px;
    height: ${props => props.top || props.bottom ? '30px' : '60px'};
  }
`
const ExtraInfo = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`
const Thumb = styled.div`
  height: 30px;
  width: 30px;
  margin-top: 4px;
  margin-left: 8px;
  cursor: pointer;
  background-image: ${({ image }) => `url(${image})`};
  background-repeat: no-repeat;
  background-size: cover;
  border-radius: 6px;
`
const NameContainer = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: center;
`

const renderHour = props => moment(props.date).format('HH:mm')

const getContext = (context) => {
  const value = context.map((currentValue, index) => {
    if (index !== 0) {
      return (
        <ContextContainer key={index}>
          {currentValue}
        </ContextContainer>
      )
    }
  })

  return value
}

const getDescription = (description, props) => {
  if (description) {
    const descriptionWithBr = description.split('<br />')
    const containsPhoto = description.includes('foto')
    const containsSala = description.includes('sala')

    if (containsPhoto) {
      const newDescription = description.split(': ')
      return (
        <NameContainer>
          {newDescription[0]}
          {(isNaN(newDescription[1])) &&(
            <Thumb image={newDescription[1]} onClick={() => props.onPhotoClick(newDescription[1])} />
          )}
        </NameContainer>
      )
    }
    if (containsSala) {
      return (
        <div>
          <NameContainer>
            {description}
          </NameContainer>
        </div>
      )
    }
    if (descriptionWithBr.length > 1) {
      return (
        <div>
          <NameContainer>
            {descriptionWithBr[0]}
          </NameContainer>
          {getContext(descriptionWithBr)}
        </div>
      )
    }

    return (
      <div>
        <NameContainer>
          {descriptionWithBr[0]}
        </NameContainer>
      </div>
    )
  }

  return null
}

const isActivity = (activity, description) => {
  if (activity) {
    return activity.includes('activity_')
  }

  if (description) {
    return description.includes('Terminó')
  }

  return false
}

const getName = (props, registered_by) => {
  if (props.user_name) {
    return props.user_name
  }

  if (registered_by) {
    return registered_by.name
  }

  return ''
}


const ActivityTableCell = ({ description, index, photo_url, registered_by, ...props }) => (
  <CellContainer index={index}>
    <LinkLine top={props.top} bottom={props.bottom} alone={props.alone} />
    <div style={{ zIndex: 1 }}>
      <CircleContainer index={index}>
        <Circle color={props.color} />
      </CircleContainer>
    </div>
    <InfoContainer>
      {getDescription(description, props)}
    </InfoContainer>
    {(!props.parent && isActivity(props.type, description)) && (
      <DeleteButton
        transparent
        small
        onClick={() => props.onDeleteActivity(props.activity_id)}
      >
        <CancelIcon src="/assets/cancel_icon.svg" />
        <DeleteLabel>Borrar</DeleteLabel>
      </DeleteButton>
    )}
     {((props.user.role.includes('Director')||props.user.role.includes('Back Office Admin')) && (description.includes('Salió'))) && (
      <DeleteButton
        transparent
        small
        onClick={() => props.onEditCheckout(props.activity_id)}
      >
        <CancelIcon src="/assets/edit.svg" />
        <DeleteLabel>Editar</DeleteLabel>
      </DeleteButton>
    )}
    <ContextContainer>
      <ExtraInfo>
        <span>{renderHour(props)}</span>
        <span>{getName(props, registered_by)}</span>
      </ExtraInfo>
    </ContextContainer>
  </CellContainer>
)

ActivityTableCell.propTypes = {
  index: PropTypes.number.isRequired,
  top: PropTypes.bool,
  bottom: PropTypes.bool,
}

ActivityTableCell.defaultProps = {
  context: '',
  top: false,
  bottom: false,
}

export default ActivityTableCell



// WEBPACK FOOTER //
// ./src/Components/ActivityTableCell.jsx